import { MetaReducer, createReducer, on } from '@ngrx/store';

import { hydrationMetaReducer, patchInitialValue } from '@main-application/store/reducers/hydration-meta.reducer';
import {
  setTurnoverListSorting,
  setWidgetsCollapseState,
  toggleTurnoverListAssignees,
  toggleTurnoverListSteps,
} from '@main-application/turnovers/components/turnover-list/store/actions/turnover-list.actions';
import { SortItem } from '@shared/interfaces/sort-item';

export const turnoverListFeatureKey = 'turnovers-list';

export interface TurnoverListState {
  stepAssignees: boolean;
  showSteps: boolean;
  propertySorting: { [key: number]: SortItem };
  widgetsState: {
    collapsed: boolean;
    manually: boolean;
  };
}

export const initialState: TurnoverListState = patchInitialValue(
  {
    propertySorting: {},
    stepAssignees: false,
    showSteps: false,
    widgetsState: {
      collapsed: false,
      manually: false,
    },
  },
  turnoverListFeatureKey
);

export const metaTurnoverListReducers: Array<MetaReducer<any, any>> = [
  hydrationMetaReducer<TurnoverListState>(turnoverListFeatureKey),
];

export const reducer = createReducer(
  initialState,
  on(setTurnoverListSorting, (state, action) => ({
    ...state,
    ...{ propertySorting: { ...state.propertySorting, ...{ [action.propertyId]: action.sorting } } },
  })),
  on(toggleTurnoverListAssignees, (state, action) => ({
    ...state,
    ...action,
  })),
  on(toggleTurnoverListSteps, (state, action) => ({
    ...state,
    ...action,
  })),
  on(setWidgetsCollapseState, (state, action) => ({
    ...state,
    widgetsState: action,
  }))
);
